import { useState, useEffect } from "react";
import { fetchSuppliers, updateSupplier } from "../../../../api/supplierManagement/supplierApi.js";

export default function useSupplierManagement() {
  const [activeFilter, setActiveFilter] = useState("Dispensary");
  const [search, setSearch] = useState("");
  const [showAddForm, setShowAddForm] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [suppliers, setSuppliers] = useState([]);
  const [popupMsg, setPopupMsg] = useState("");

  useEffect(() => {
    const mapFilterToDepartment = (f) => {
      if (f === "Dispensary") return 1;
      if (f === "Front Shop") return 2;
      if (f === "Clinic") return 3;
      return undefined;
    };
    const normalizeCategory = (val) => {
      if (Array.isArray(val)) {
        if (val.length === 1 && typeof val[0] === 'string' && val[0].includes(',')) {
          return val[0].split(',').map(s => s.trim()).filter(Boolean);
        }
        return val.map(s => (typeof s === 'string' ? s.trim() : s)).filter(Boolean);
      }
      if (typeof val === 'string') {
        if (!val.trim()) return [];
        return val.split(',').map(s => s.trim()).filter(Boolean);
      }
      return [];
    };
    const load = async () => {
      const departmentid = mapFilterToDepartment(activeFilter);
      const data = await fetchSuppliers({ departmentid });
      const mapped = (data || []).map((s) => ({
        suppliercode: s.suppliercode,
        supplierName: s.suppliername,
        address: s.address || "",
        sapc: s.sapc || "",
        sahpra: s.sahpra || "",
        vatnumber: s.vatnumber || "",
        alternatenumber: s.alternatenumber || "",
        category: normalizeCategory(s.category),
        docurl: s.docurl || "",
        documentname: s.documentname || "",
        status: typeof s.status === 'string' ? s.status : 'Active',
        contact: {
          name: s.primarycontactname || "",
          phone: s.cellphonenumber || "",
          email: s.email || "",
        },
        totalOrders: "N/A",
        lastSupplied: "N/A",
        disabled: s.status && typeof s.status === 'string' ? s.status.toLowerCase() !== "active" : false,
      }));
      setSuppliers(mapped);
    };
    load();
  }, [activeFilter]);

  const handleEdit = (row) => {
    setSelectedSupplier(row);
    setIsEditing(true);
    setShowAddForm(true);
  };

  const handleEnable = async (row) => {
    try {
      if (!row?.suppliercode) return;
      await updateSupplier(row.suppliercode, { status: 'Active' });
      const departmentid = activeFilter === 'Dispensary' ? 1 : activeFilter === 'Front Shop' ? 2 : activeFilter === 'Clinic' ? 3 : undefined;
      const data = await fetchSuppliers({ departmentid });
      const mapped = (data || []).map((s) => ({
        suppliercode: s.suppliercode,
        supplierName: s.suppliername,
        address: s.address || "",
        sapc: s.sapc || "",
        sahpra: s.sahpra || "",
        vatnumber: s.vatnumber || "",
        alternatenumber: s.alternatenumber || "",
        category: (Array.isArray(s.category) ? (s.category.length === 1 && typeof s.category[0] === 'string' && s.category[0].includes(',') ? s.category[0].split(',').map(x=>x.trim()).filter(Boolean) : s.category.map(x=> (typeof x==='string'?x.trim():x)).filter(Boolean)) : (typeof s.category === 'string' ? s.category.split(',').map(x=>x.trim()).filter(Boolean) : [])),
        docurl: s.docurl || "",
        documentname: s.documentname || "",
        status: typeof s.status === 'string' ? s.status : 'Active',
        contact: { name: s.primarycontactname || "", phone: s.cellphonenumber || "", email: s.email || "" },
        totalOrders: "N/A",
        lastSupplied: "N/A",
        disabled: s.status && typeof s.status === 'string' ? s.status.toLowerCase() !== "active" : false,
      }));
      setSuppliers(mapped);
      setPopupMsg("✅ Supplier enabled");
    } catch (e) {
      console.error(e);
    }
  };

  const handleDisable = async () => {
    try {
      if (!selectedSupplier?.suppliercode) return;
      await updateSupplier(selectedSupplier.suppliercode, { status: 'Disabled' });
      const departmentid = activeFilter === 'Dispensary' ? 1 : activeFilter === 'Front Shop' ? 2 : activeFilter === 'Clinic' ? 3 : undefined;
      const data = await fetchSuppliers({ departmentid });
      const mapped = (data || []).map((s) => ({
        suppliercode: s.suppliercode,
        supplierName: s.suppliername,
        address: s.address || "",
        sapc: s.sapc || "",
        sahpra: s.sahpra || "",
        vatnumber: s.vatnumber || "",
        alternatenumber: s.alternatenumber || "",
        category: Array.isArray(s.category) ? s.category : [],
        docurl: s.docurl || "",
        documentname: s.documentname || "",
        status: typeof s.status === 'string' ? s.status : 'Active',
        contact: { name: s.primarycontactname || "", phone: s.cellphonenumber || "", email: s.email || "" },
        totalOrders: "N/A",
        lastSupplied: "N/A",
        disabled: s.status && typeof s.status === 'string' ? s.status.toLowerCase() !== "active" : false,
      }));
      setSuppliers(mapped);
      setShowAddForm(false);
      setIsEditing(false);
      setSelectedSupplier(null);
      setPopupMsg("✅ Supplier disabled");
    } catch (e) {
      console.error(e);
    }
  };

  return {
    activeFilter,
    setActiveFilter,
    search,
    setSearch,
    showAddForm,
    setShowAddForm,
    isEditing,
    setIsEditing,
    selectedSupplier,
    setSelectedSupplier,
    suppliers,
    setSuppliers,
    popupMsg,
    setPopupMsg,
    handleEdit,
    handleEnable,
    handleDisable,
  };
}
